const NUMERIC_TIMESTAMP_PATTERN = /^\d+(?:\.\d+)?$/;
const MONTHS_PT_SHORT = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

function parseDateValue(value) {
  if (value == null || value === '') return null;

  const text = String(value).trim();
  const numericValue = NUMERIC_TIMESTAMP_PATTERN.test(text) ? Number(text) : null;
  const date = numericValue != null
    ? new Date(Math.abs(numericValue) < 100_000_000_000 ? numericValue * 1000 : numericValue)
    : new Date(text);

  return Number.isNaN(date.getTime()) ? null : date;
}

function tradingDateParts(value) {
  if (value == null || value === '') return null;

  const text = String(value).trim();
  const dateMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (dateMatch) {
    const [, year, month, day] = dateMatch;
    return { year, month, day };
  }

  const date = parseDateValue(text);
  if (!date) return null;

  const [year, month, day] = date.toISOString().slice(0, 10).split('-');
  return { year, month, day };
}

export function formatTradingDate(value) {
  const parts = tradingDateParts(value);
  if (!parts) return '—';
  return `${parts.day}/${parts.month}/${parts.year}`;
}

export function formatDateTimeBR(value) {
  const date = parseDateValue(value);
  if (!date) return '—';

  const parts = new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);
  const part = type => parts.find(item => item.type === type)?.value || '';

  return `${part('day')}/${part('month')}/${part('year')} ${part('hour')}:${part('minute')}`;
}

export function formatTradingDateShort(value) {
  const parts = tradingDateParts(value);
  if (!parts) return '—';
  return `${parts.day}/${MONTHS_PT_SHORT[Number(parts.month) - 1] || parts.month}`;
}